import ResetPasswordPage from './ResetPasswordPage';

export default ResetPasswordPage;


// WEBPACK FOOTER //
// ./src/components/pages/ResetPasswordPage/index.js